import React, { createContext, useContext, useState } from "react";

// Create the context
const FieldContext = createContext();

// Create a provider component
export const FieldProvider = ({ children }) => {
  const [selectedField, setSelectedField] = useState({
    coordinates: [],
    area: 0,
    fieldName: ""
  });

  // Function to update the selected field data
  const selectField = (coordinates, area, fieldName) => {
    setSelectedField({ coordinates, area, fieldName });
  };

  return (
    <FieldContext.Provider value={{ selectedField, selectField }}>
      {children}
    </FieldContext.Provider>
  );
};

// Custom hook to use the field context
export const useField = () => {
  return useContext(FieldContext);
};